import Grid from '@mui/material/Grid';

export const practitionerUsedTechnicsFields = [
  {
    name: 'opticalImpression',
    label: 'Utilisation empreinte optique :',
    type: 'switch',
    wrapper: {component: Grid, props: {item: true, xs: 12, sm: 6}}
  },
  {
    name: 'cerecCFAO',
    label: 'Utilisation CEREC/CFAO :',
    type: 'switch',
    wrapper: {component: Grid, props: {item: true, xs: 12, sm: 6}}
  }
];
